// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { useAuth } from "./AuthContext";

// const ProtectedRoute = () => {
//   const { token, loading } = useAuth();

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   // ✅ token is the real authentication
//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import axios from "axios";
// import { useAuth } from "./AuthContext";

// const ProtectedRoute = () => {
//   const { token } = useAuth();

//   const [checking, setChecking] = useState(true);
//   const [valid, setValid] = useState(false);

//   useEffect(() => {
    
//     const validateSession = async () => {
//       try {
//         if (!token) {
//           setValid(false);
//           setChecking(false);
//           return;
//         }

//         await axios.get(
//           "http://localhost:5000/api/auth/validate",
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         setValid(true);

//       } catch (error) {
//         const message =
//           error?.response?.data?.message ||
//           "Session Expired";

//         alert(message);

//         localStorage.removeItem("authToken");
//         localStorage.removeItem("user");

//         setValid(false);
//       } finally {
//         setChecking(false);
//       }
//     };

//     validateSession();
//   }, [token]);

//   if (checking) {
//     return <div>Checking License...</div>;
//   }

//   if (!valid) {
//     return <Navigate to="/login" replace />;
//   }

//   return <Outlet />;
// };

// export default ProtectedRoute;


import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = () => {
  const { token, loading } = useAuth();

  if (loading) {
    return <div>Checking License...</div>;
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;